// extracted by mini-css-extract-plugin
export default {"container":"CommonPinSettings_container__o6Tfu","controls":"CommonPinSettings_controls__8Anxk","title":"CommonPinSettings_title__hLCDY","label":"CommonPinSettings_label__edUJi"};